<template>
    <v-dialog v-model="showSuccessDialog.active" persistent  :width="313">
        <v-card>
          <div class="success-dialog">
            <div class="success-header">
              <div class="success-header-banner">
                <img src="@/assets/images/congratsbanner.svg" alt="success"/>
                <div>Success!</div>
              </div>
              <div class="success-header-close">
                <v-icon @click="close()">close</v-icon>
              </div>
            </div>

            <div class="success-content">
              {{ showSuccessDialog.message }}
            </div>
            <div class="button-container">
              <button class="button-blue" @click="close()">{{ showSuccessDialog.buttonText || "Okay!" }}</button>
            </div>
          </div>
        </v-card>
    </v-dialog>
</template>

<script>
    import store from "@/store";
    import subscribeToStore from "@/mixins/subscribeToStore";

    export default {
        data: ()=> ({
          showSuccessDialog: store.state.showSuccessDialog
        }),
        props: {
            value: Boolean
        },
        mixins: [subscribeToStore],
        mounted() {
          this.subscribeToStore(['showSuccessDialog'])
        },
        methods: {
          close() {
            store.commit('setShowSuccessDialog', {active: false, message: null});
          }
        }
    }
</script>
